import { render, staticRenderFns } from "./DirectSaleSelect.vue?vue&type=template&id=08827f65&scoped=true&"
import script from "./DirectSaleSelect.vue?vue&type=script&lang=js&"
export * from "./DirectSaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./DirectSaleSelect.vue?vue&type=style&index=0&id=08827f65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08827f65",
  null
  
)

export default component.exports